import React from 'react';

import { MobileFilterWrapper } from '@/modules/CarsStock/components/common.styles';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  setCarPowerReserve,
  setPage,
} from '@/store/reducers/cars-stock';
import { RangeType } from '@/typings/common';
import StockFilterRange from '@/components/StockFilterRange';

function PowerReserveFilter() {
  const dispatch = useTypedDispatch();
  const selectedPowerReserve =
    useTypedSelector(getSelectedFilters).selectedParams.selectedPowerReserve;

  const handleBlurPowerReserve = (powerReserve: RangeType) => {
    dispatch(setCarPowerReserve(powerReserve));
    dispatch(setPage(1));
  };

  return (
    <MobileFilterWrapper>
      <StockFilterRange
        label="Запас хода для электро, км"
        values={selectedPowerReserve}
        onBlur={handleBlurPowerReserve}
      />
    </MobileFilterWrapper>
  );
}

export default PowerReserveFilter;
